export default __webpack_public_path__ + "static/media/word.b13a74bb.png";